import get from 'lodash/get';
import { request } from 'lib';
import { UiToast, UiModal } from 'components';
import { getStore } from '../store';

const loadInfo = () => {
  const {
    room: { roomInfo, roomId },
    lianmai: { joinLine },
  } = getStore();
  request.cryolite
    .get('/api/v2/join/line/info', {
      room_id: roomId,
    })
    .then((res) => {
      const { mode_info } = res.data;
      // 按照 live_streams 顺序排序
      if (roomInfo.isJoinLine && mode_info && mode_info.multi_pk_info) {
        mode_info.multi_pk_info = roomInfo.live_streams.map((item) => {
          return mode_info.multi_pk_info.find((item2) => {
            return item2.room_id === item.uid;
          });
        });
      }

      joinLine.updateInfo(res.data);

      const list = res.data.mode_info.multi_pk_info || [];

      // roomInfo.live_streams.forEach((item) => {
      //   list.forEach((item2) => {
      //     if (item.uid === item2.room_id) {
      //       item.setPkInfo(item2)
      //     }
      //   })
      // })
    });
};

let searchId = '';

const reloadSearch = () => {
  loadSearch(searchId);
};

// 搜索主播
const loadSearch = (id) => {
  searchId = id;
  if (!id) {
    return;
  }
  const {
    lianmai: { joinLine },
  } = getStore();
  request.cryolite
    .get('/api/v2/join/line/search/v2', {
      query: id,
    })
    .then((res) => {
      joinLine.updateSearchStar(res.data.items || []);
    });
};

const loadHistoryList = () => {
  const {
    lianmai: { joinLine },
  } = getStore();
  request.cryolite.get('/api/v2/join/line/history').then((res) => {
    joinLine.updateHistoryList(res.data.items);
  });
};

// 我的关注
const loadFocusList = () => {
  const {
    lianmai: { joinLine },
  } = getStore();
  request.cryolite.get('/api/v2/join/line/follow/list').then((res) => {
    joinLine.updateFocusList(res.data.items);
  });
};

// 正在邀请的主播列表
const loadInviteList = () => {
  const {
    lianmai: { joinLine },
  } = getStore();
  request.cryolite.get('/api/v2/join/line/invite/list').then((res) => {
    joinLine.updateInviteList(res.data.items);
  });
};

const invite = (roomId) => {
  request.cryolite
    .get(
      '/api/v2/join/line/invite/anchor',
      {
        target_room: roomId,
      },
      {
        event: 'joinLine',
        event_type: 'invite',
        desc: '邀请',
      },
    )
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已发出邀请');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

// 取消邀请
const cancelInvite = (roomId) => {
  request.cryolite
    .post(`/api/v2/join/line/invite/cancel?target_room=${roomId}`, null, {
      event: 'joinLine',
      event_type: 'cancelInvite',
      desc: '取消邀请',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已取消邀请');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const agreeInvite = () => {
  request.cryolite
    .post('/api/v2/join/line/invite/agree', null, {
      event: 'joinLine',
      event_type: 'agreeInvite',
      desc: '同意邀请',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已同意');
    })
    .catch((res) => {
      UiToast.fail(res.msg || '操作异常');
    });
};

const refuseInvite = () => {
  request.cryolite
    .post('/api/v2/join/line/invite/refuse', null, {
      event: 'joinLine',
      event_type: 'refuseInvite',
      desc: '拒绝邀请',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已拒绝');
    })
    .catch((res) => {
      UiToast.fail(res.msg || '操作异常');
    });
};

const exit = () => {
  const { room } = getStore();

  request.cryolite
    .post('/api/v2/join/line/exit', null, {
      event: 'joinLine',
      event_type: 'exit',
      desc: '退出连麦',
    })
    .then((res) => {
      reload();
      room.update();
      UiToast.success('已断开连麦');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

// 关播时退出
const liveOffExit = () => {
  const info = get(getStore(), 'lianmai.joinLine.info') || {};
  const { chatting, inviting, matching } = info;

  if (inviting) {
    UiToast.fail('正在连麦邀请中，请先退出');
    throw new Error('正在连麦邀请中，请先退出');
  }
  if (matching) {
    UiToast.fail('正在连麦匹配中，请先退出');
    throw new Error('正在连麦匹配中，请先退出');
  }
  if (chatting) {
    exit();
  }
};

const joinMatch = () => {
  request.cryolite
    .post('/api/v2/join/line/match/join', null, {
      event: 'joinLine',
      event_type: 'joinMatch',
      desc: '发起匹配',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已发起匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const cancelMatch = () => {
  request.cryolite
    .post('/api/v2/join/line/match/cancel', null, {
      event: 'joinLine',
      event_type: 'cancelMatch',
      desc: '取消匹配',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已取消匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

// 心跳
const heart = () => {
  request.cryolite
    .get('/api/v2/join/line/heart', null, {
      event: 'joinLine',
      event_type: 'heart',
      desc: '心跳',
    })
    .then((res) => {});
};

// 发起PK
const startPk = (pk_duration, cb) => {
  return request.cryolite
    .post(
      '/api/v2/join/line/open',
      {
        pk_duration,
        mode: 'MULTI_PK',
      },
      {
        event: 'joinLine',
        event_type: 'startPk',
        desc: '发起PK',
      },
    )
    .then((res) => {
      UiToast.success('已发起PK');
      cb && cb();
    })
    .catch((res) => {
      UiToast.fail(res.msg || '操作异常');
    });
};

const loadConfig = () => {
  return request.cryolite.get('/api/v2/join/line/mode/config/info');
};

const reload = () => {
  loadInfo();
  loadHistoryList();
  loadFocusList();
  loadInviteList();
  reloadSearch();
};

export default {
  loadInfo,
  loadSearch,
  reloadSearch,
  loadHistoryList,
  loadFocusList,
  loadInviteList,
  invite,
  cancelInvite,
  agreeInvite,
  refuseInvite,
  exit,
  liveOffExit,
  joinMatch,
  cancelMatch,
  reload,
  heart,
  startPk,
  loadConfig,
};
